import { IonContent } from '@ionic/react';
import classNames from 'classnames';

export const QuirkIonContent: React.FC<{
	children: JSX.Element;
	scroll?: boolean;
	fullscreen?: boolean;
	flush?: boolean;
	testId?: string;
	safeAreaTop?: boolean;
	padding?: boolean;
}> = ({ children, scroll = true, fullscreen = false, flush = false, testId, safeAreaTop = false, padding = false }) => {
	return (
		<IonContent fullscreen={fullscreen} scrollY={false}>
			<div
				className={classNames(
					'innerContent',
					scroll && 'scrollContent',
					safeAreaTop && 'safe-area-top',
					padding && 'quirk-ion-content-padding'
				)}
				style={{ paddingTop: flush ? 0 : '' }}
				data-testid={testId}
			>
				{children}
			</div>
		</IonContent>
	);
};
